<template>
	<div></div>
</template>

<script>
import axios from 'axios';
import { getToken, getMessaging } from 'firebase/messaging';
import { PUBLIC_VAPID_KEY } from '@/config/firebase-messaging.js';

export default {
	name: 'Logout',
	async created() {
		try {
			await this.unregisterToken();
			localStorage.removeItem('token');
			localStorage.removeItem('accessibility_enabled');
			await this.$store.dispatch('profile/clearStore');
			this.$router.push({ name: 'Login' });
		} catch (error) {
			localStorage.removeItem('token');
			localStorage.removeItem('accessibility_enabled');
			this.$router.push({ name: 'Login' });
		}
	},
	methods: {
		async unregisterToken() {
			try {
				if (Notification == null) return;
				if (Notification.permission != 'granted') return;

				const messaging = getMessaging();
				const token = await getToken(messaging, { vapidKey: PUBLIC_VAPID_KEY });
				if (token) {
					await axios.post('/api/notifications/unregister-token', { token });
				}
			} catch (error) {
				console.error('Error unregistering token:', error);
			}
		},
	},
};
</script>
